import { brand } from '@brand';

/** Main palette of the brand selected at build time. */
export const brandColors = brand.palette.colors;
export const brandRgb = brand.palette.rgb;
export const brandGradients = brand.palette.gradients;

export type BrandColorKey = keyof typeof brandColors;
export type BrandRgbKey = keyof typeof brandRgb;

/** rgba() from a channel token, e.g. brandRgba('brandPrimary', 0.1) -> 'rgba(0,51,141,0.1)'. */
export function brandRgba(channel: BrandRgbKey, alpha: number): string {
  return `rgba(${brandRgb[channel]},${alpha})`;
}

/** Shadow rgba() whose alpha scales with the pack's --shadow-strength (1 keeps `alpha`, 0 hides it). */
export function brandShadowRgba(channel: BrandRgbKey, alpha: number): string {
  return `rgba(${brandRgb[channel]},calc(${alpha} * var(--shadow-strength, 1)))`;
}

/** Shadow rgba() from a `#rrggbb` color, alpha scaled by --shadow-strength. */
export function hexShadowRgba(hex: string, alpha: number): string {
  const n = parseInt(hex.slice(1, 7), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},calc(${alpha} * var(--shadow-strength, 1)))`;
}
